export const API_ROUTES = {
  auth: {
    init: "/auth/init/",
    mannualLogin: "/auth/signin/",
    magicLinkLogin: "/auth/smart-signup/",
    registerVerify: "/auth/google-auth/",
    googleLogin: "/auth/google-auth/",
    magicLinkVerify: "/auth/smart-login/",
    profile: "/users/profile/",
    adminRegister: "/auth/signup/",
    otpVerify: "/auth/verify/otp/",
    manualLoginVerify: "/auth/verify/otp_code/",
    forgotPassword: "/auth/password/forgot/",
    resetPassword: "/auth/password/reset/",
    setNewPassword: "/auth/set-new-password/",
    changePassword: "/auth/password/change/",
    regenerateToken: "/auth/resend/otp/",
    refreshToken: "/auth/token/refresh/",
    logout: "/auth/logout/",
    oAuth: { verify: "/auth/oauth/verify/", login: "/auth/oauth/login/" }
  },
  country: {
    list: "/numbers/country/"
  },
  profile: {
    base: `/user/profile/`
  },
  call: {
    logs: "/communication/voice/call-logs/",
    callLogDetails: "/communication/voice/call-logs/dialer/",
    listDialerCallLogs: "/call/dialer/log/",
    listCommonCallLogs: `/call/dialer/log/communication/`,
    getCommunicationId: `/communication/logs/`,
    deleteCallLog: `/call/delete/`,
    updateCallForwardingStrategy: `/call/forward/`,
    downloadAudio: `/call/{call_id}/recordings/{recording_id}/download/`,
    callAudio: `/call/{call_id}/recordings/{recording_id}/`
  },
  comments: {
    createComment: `/comments/`,
    listComments: `/comments/{id}/`
  },
  credits: "/credits/",
  charges: "/plans/?plan_type=Charge",
  cards: "/card/",
  admin: {
    callHistory: `/portal/call-records`
  },
  number: {
    listNumber: `/numbers/assign/`,
    dialNumber: `/numbers/`,
    deleteNumber: `/number/delete/`,
    listAvailableNumbers: `/voip/numbers/search/`,
    buyNumber: `/voip/numbers/buy/`,
    reserve: "/voip/numbers/reserve/",
    select: `/numbers/select/`,
    updateName: "/numbers/rename/",
    assign: {
      base: "/numbers/assign",
      agent: `/numbers/assign/agent/`
    },
    agents: {
      assign: "/agents/assign/numbers/"
    },

    numberDetail: "/number/{id}"
  },

  voipNumber: {
    list: `/voip/numbers/search/`,
    reserve: `/voip/numbers/reserve/`,
    numberAttach: `/subscriptions/number-attach/`
  },

  pricing: {
    checkout: "/subscriptions/checkout-url/",
    plan: {
      create: "/plans/create/",
      list: "/plans/"
    },
    invoice: {
      link: "/invoices/chargebee/"
    }
  },
  communication: {
    webToken: "/communication/voice/web-token/",
    provider: "/communication/voice/provider/"
  },
  subscription: {
    list: "/subscriptions/",
    additionalNumbers: "/subscriptions/numbers/",
    listPricing: `/plan_price/`,
    getSubscriptionInfo: `/subscription/info/`,
    userBillingList: `/subscription/billing/list/`,
    isNumberReserved: `/reserved/number/`,
    buyPlanInformation: `/plan_price/buy/`,
    updateSubscription: `/subscriptin/update/{subscriptionId}/`,
    cancelSubscription: `/subscription/cancel/{subscription_id}/`,
    trialEnd: "subscriptions/trial-end/"
  },
  contact: {
    base: "/contacts/",
    delete: "/contacts/delete/",
    upload: "/contacts/upload/",
    block: "/communication/block/",
    unblock: "/communication/unblock/",
    list: "/communication/blocked-list/",
    checkBlockID: "/communication/check/"
  },
  workspace: {
    list: "/workspaces/",
    agents: "/workspaces/{id}/agents/"
  },
  agent: {
    base: "/agents/",
    reinvite: "/agents/reinvite/",
    accept: "/agents/accept/",
    subscription: "/agents/subscription/",
    delete: "/agents/delete/",
    generateToken: "/agents/invitation/token/"
  },
  agentGroup: {
    base: "/groups/",
    list: "/workspaces/",
    delete: "/groups/delete/"
  },
  device: {
    list: "/devices/",
    update: "/device/signin/",
    qrCode: "/devices/attach/",
    logout: "/devices/logout/",
    fcm: "devices/fcm/",
    history: "/devices/history/",
    regenerateCode: "/devices/regenerate-code/"
  },
  message: {
    base: "/communication/messages/",
    portal: "/communication/messages/portal/",
    dial: "/communication/messages/dial/",
    thread: "/communication/messages/thread/",
    seen: "/communication/messages/seen/"
  },
  providers: {
    list: "/voip/providers/"
  },
  voicemail: {
    list: "/communication/voicemails/"
  },
  settings: {
    numberDetails: "/numbers/{number_id}/",
    businessHours: "/numbers/{number_id}/settings/business-hours/",
    afterBusinessHoursVoicemail:
      "/numbers/{number_id}/settings/voicemail-audio/"
  },
  socket: {
    base: "/websocket/ticket/"
  },
  callFLow: {
    base: "/numbers/{numberID}/settings/call-flow/"
  },
  integrations: {
    base: "/integrations/",
    connected: "/integrations/connected/",
    crmRedirect: "/integrations/redirect/crm",
    connectCRM: "/integrations/connect/",
    entities: "/integrations/entities"
  }
} as const
